export const realOrderStorageKeyPrefix = 'trackingPageRealOrder'
